import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '@shared/services/shared.service';
import { IAffectedPerson } from 'app/models/compliance/affected-person';

@Component({
  selector: 'app-affected-person',
  templateUrl: './dialog-affected-person.component.html',
  styleUrls: ['./dialog-affected-person.component.scss']
})
export class AffectedPersonDialogComponent implements OnInit {
  public person: IAffectedPerson = {
    id: 0,
    clientGuid: '',
    firstName: '',
    middleName: '',
    lastName: '',
    address: '',
    phone: '',
    email: '',
    dob: '',
    gender: '',
    relationship: '',
    relationshipOther: '',
    canContact: false,
    whyNoContact: '',
    otherContactReason: '',
    clientNarrative: '',
    clientResponded: false,
    servicesReceived: '',
    clientSchedule: '',
    incidentLocation: '',
    dateAdmitted: '',
    currentPatient: false,
    dateDischarged: ''
  };

  public affectedPersonForm = new FormGroup({
    firstName: new FormControl(''),
    middleName: new FormControl(''),
    lastName: new FormControl(''),
    address: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl('', Validators.email),
    dob: new FormControl<Date | null>(null),
    gender: new FormControl(''),
    relationship: new FormControl(''),
    relationshipOther: new FormControl(''),
    canContact: new FormControl(null),
    whyNoContact: new FormControl(''),
    otherContactReason: new FormControl(''),
    incidentLocation: new FormControl(''),
    servicesReceived: new FormControl(''),
    clientSchedule: new FormControl(''),
    dateAdmitted: new FormControl<Date | null>(null),
    currentPatient: new FormControl(null),
    dateDischarged: new FormControl<Date | null>(null)
  });

  public relationshipOptions: string[] = [
    'Current Staff',
    'Former Staff',
    'OR APS',
    'OR DHS',
    'Other State Agency',
    'Federal Agency',
    'Media',
    'Other'
  ]

  public sharedService = inject(SharedService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: {person: IAffectedPerson},
              private dialogRef: MatDialogRef<AffectedPersonDialogComponent>) {
               this.person = data.person;
              }

  ngOnInit(): void {
    this.updateAffectedPersonForm();
  }

  private updateAffectedPersonForm(): void {
    this.affectedPersonForm.patchValue({
      firstName: this.person.firstName,
      middleName: this.person.middleName,
      lastName: this.person.lastName,
      address: this.person.address,
      phone: this.person.phone,
      email: this.person.email,
      dob: this.person.dob ? new Date(this.person.dob) : null,
      gender: this.person.gender,
      relationship: this.person.relationship,
      relationshipOther: this.person.relationshipOther,
      canContact: this.person.canContact,
      whyNoContact: this.person.whyNoContact,
      otherContactReason: this.person.otherContactReason,
      incidentLocation: this.person.incidentLocation,
      servicesReceived: this.person.servicesReceived,
      clientSchedule: this.person.clientSchedule,
      dateAdmitted: this.person.dateAdmitted ? new Date(this.person.dateAdmitted) : null,
      currentPatient: this.person.currentPatient,
      dateDischarged: this.person.dateDischarged ? new Date(this.person.dateDischarged) : null
    });
  }

  public updateAffectedPerson(): void {
    let formValues = this.affectedPersonForm.getRawValue();
    this.person.firstName = formValues.firstName || '';
    this.person.middleName = formValues.middleName || '';
    this.person.lastName = formValues.lastName || '';
    this.person.address = formValues.address || '';
    this.person.phone = formValues.phone || '';
    this.person.email = formValues.email || '';
    this.person.dob = formValues.dob ? formValues.dob.toISOString().split('T')[0] : '';
    this.person.gender = formValues.gender || '';
    this.person.relationship = formValues.relationship || '';
    this.person.relationshipOther = formValues.relationshipOther || '';
    this.person.canContact = formValues.canContact;
    this.person.whyNoContact = formValues.whyNoContact || '';
    this.person.otherContactReason = formValues.otherContactReason || '';
    this.person.incidentLocation = formValues.incidentLocation || '';
    this.person.servicesReceived = formValues.servicesReceived || '';
    this.person.clientSchedule = formValues.clientSchedule || '';
    this.person.dateAdmitted = formValues.dateAdmitted ? formValues.dateAdmitted.toISOString().split('T')[0] : '';
    this.person.currentPatient = formValues.currentPatient;
    this.person.dateDischarged = formValues.dateDischarged ? formValues.dateDischarged.toISOString().split('T')[0] : '';
  }

  public savePerson(): void {
    this.updateAffectedPerson();
    this.dialogRef.close(this.person);
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  relationShipExtraDetails(relationship: string): boolean {
    return this.relationshipOptions.includes(relationship);
  }
}
